<template>
  <div class="c-label-list" ref="target">
    <!-- p-menus-no-detail-infomation__innerのグラデーションをなくすためにinner-accordionを記述 -->
    <div
      class="p-menus-no-detail-infomation__inner"
      :style="{ height: openHeight + 'px' }"
      >
      <div ref="infomationText">
        <ul class="c-lists">
          <li v-for="(item, i) in list" :key="i" class="c-lists__list" v-if="item.name || item.ary">
            <p
              class="c-lists__list__label"
              :class="{ 'c-lists__list__label--wide': wide == 1 }"
            >
              {{ item.label }}
            </p>
            <!-- 1: text, 2: link, 3:営業時間 , 4: 施設URL -->
            <p
              class="c-lists__list__text"
              v-if="item.type == 1"
              v-html="item.name"
            ></p>
            <p v-else-if="item.type == 2" class="c-lists__list__inquiry">
              <a
                class="c-lists__list__inquiry--link mr5"
                :href="item.url"
                target="_blank"
              >
                {{ item.name }}
                <Icon
                  :color="'#0D76BF'"
                  name="action_link"
                  width="24"
                  height="24"
                />
              </a>
            </p>
            <ul v-else-if="item.type == 3">
              <li
                v-for="(itemAry, i) in item.ary"
                :key="i"
                class="c-lists__list__item"
              >
                <!-- check with menuList to get plan end date -->
                <p
                  class="c-lists__list__text"
                  v-html="getHTMLItemAry(item.label, itemAry)"
                ></p>
              </li>
              <a
                :href="item.linkUrl"
                v-if="item.linkUrl && item.linkNm"
                class="item-link"
                target="_blank"
                >{{ item.linkNm
                }}<Icon
                  name="action_external_link"
                  width="18"
                  height="18"
                  class="icon"
              /></a>
            </ul>
            <p v-else-if="item.type == 4" class="c-lists__list__url">
              <a class="c-lists__list__url--link" :href="item.url" target="_blank">
                {{ item.name }}
              </a>
            </p>
          </li>
        </ul>
      </div>
    </div>
    <!-- アコーディオン「閉じる」「もっと見る」 -->
    <div
      class="p-menus-no-detail-infomation__more"
      :class="{ 'p-menus-no-detail-infomation__more--disabled': !isShowToggle }"
    >
      <a
        href="javascript:;"
        class="c-text-button c-text-button--sm c-text-button--left"
        :class="{'p-menus-no-detail-infomation__more--close': isShowInfomation}"
        @click="getHiddenHeight(!isShowInfomation); scrollToTarget(isShowInfomation)"
        >
        {{ isShowInfomation ? "閉じる" : "もっと見る" }}
        <Icon
          :name="isShowInfomation ? 'arrow_up' : 'arrow_down'"
          width="33px"
          height="48px"
          color="gray"
        />
      </a>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    wide: {
      type: Number,
      default: 0
    },
    menuList: {
      type: Array,
      default: () => []
    },
    planId: {
      type: String,
      default: ""
    },
    menu: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isShowInfomation: false,
      openHeight: 0,
      isShowToggle: true
    };
  },
  computed: {
    infoData() {
      if (this.menu.menuInfomation) {
        return this.menu.menuInfomation;
      } else if (this.menu.planInfomation) {
        return this.menu.planInfomation;
      }
      return {}
    }
  },
  methods: {
    getPlanEndDate(itemAry) {
      // menuListが未指定や空の場合にエラーで動かないため未指定なら何もしない
      if (!this.menuList || typeof this.menuList.find !== "function") {
        return;
      }
      const planResult = this.menuList.find(
        (menu) => menu.planBasicInfo.planId == this.planId
      );
      const planRcEndDt = planResult?.planBasicInfo?.planRcEndDt;
      if (!moment(planRcEndDt).isValid()) return itemAry;
      else {
        if (moment(planRcEndDt).format("YYYY/MM/DD") === "2999/12/31") {
          return `~${moment()
            .add(1, "years")
            .set("month", 2)
            .endOf("month")
            .format("YYYY年MM月DD日 HH時mm分")}`;
        } else {
          return `~${moment(planRcEndDt).format("YYYY年MM月DD日 HH時mm分")}`;
        }
      }
    },
    getHTMLItemAry(label, itemAry) {
      let regexUrlPattern = /(http(s)?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+)/g;
      let genATag = function(all, url) {
        return '<a href="' + url + '" target="_blank">' + url + '</a>';
      }
      if(regexUrlPattern.test(itemAry)) {
        return itemAry.replace(regexUrlPattern, genATag);
      }
      return itemAry;
    },
    // ショッピングガイドの表示、非表示高さ取得・調整
    getHiddenHeight: function(flg) {
      this.$nextTick(function() {
        if (typeof flg === "boolean") {
          this.isShowInfomation = flg;
        }
        if (!this.$refs.infomationText) return;
        let infomationText = this.$refs.infomationText;
        const rectText = infomationText.getBoundingClientRect();
        if (rectText.height > 70) {
          this.openHeight = this.isShowInfomation ? rectText.height : 70;
          this.isShowToggle = true;
        } else {
          this.openHeight = rectText.height;
          this.isShowToggle = false;
        }
      });
    },
    scrollToTarget(flg) {
      if (flg) {
        let targetY = this.$refs.target.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: targetY -50
        });
      }
    }
  },
  mounted() {
    this.getHiddenHeight();
    window.addEventListener("resize", this.getHiddenHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getHiddenHeight);
  },
  watch: {
    $route() {
      this.getHiddenHeight();
    },
    menu() {
      this.getHiddenHeight();
    }
  }
};
</script>

<style lang="scss" scoped>
.item-link {
  margin-top: 8px;
  display: block;
  .icon {
    margin-left: 2px;
    vertical-align: bottom;
  }
}
@media only screen and (max-width: 1023px) {
  .c-lists__list {
    color: #1F2021;
    &__text {
      margin-left: 0.5rem;
      margin-bottom: 0;
    }
    &__label--wide {
      max-width: unset;
      white-space: inherit;
    }
  }
  .inner-accordion {
    position: relative;
    overflow: hidden;
    transition: all 300ms 0s ease;
    height: 115px;
    content: '';
  }
}
.c-text-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  user-select: none;
  background-color: transparent;
  color: #1f2021;
  vertical-align: middle;
  cursor: pointer;
  &:active {
    transform: translate(0, 1px);
  }
  &:hover {
    color: #da291c;
    text-decoration: none;
    @include mq() {
      color: #1f2021;
    }
    g {
      fill: #da291c;
    }
  }
  .c-icon {
    &:first-of-type {
      position: absolute;
      top: 50%;
      // margin-top: -0.575em;
      width: 1.325em;
      height: 1.325em;
    }
    &:not(:first-of-type) {
      margin-right: 0.25em;
      margin-left: 0.25em;
    }
  }
  &--sm {
    font-size: 0.875rem;
  }
  &--right {
    padding-right: 1.75em;
    .c-icon {
      right: 0;
    }
  }
  &--left {
    padding-left: 1.75em;
    .c-icon {
      left: 0;
    }
  }
  &--color1 {
    .c-icon {
      fill: #da291c;
    }
  }
}
@import './style.scss';
</style>
